import Component from '../inherited/Component'

export default class ResetFormElements extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._inputs = document.querySelectorAll(this._options.target)
  }

  mount () {
    this._elem.addEventListener('click', e => {
      for (let input of this._inputs) {
        if (input.type === 'checkbox') {
          input.checked = false
        } else {
          input.value = ''
        }
        input.dispatchEvent(new Event('input'))
        input.dispatchEvent(new Event('change'))
      }
    })
  }
}